import { useCallback, useEffect, useState } from "react";
import {
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle,
  MDBModalBody, MDBModalFooter, MDBBtn, MDBInput, MDBTextArea,
} from "mdb-react-ui-kit";

import { mfmThumbUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import {
  getCatalogPokemon, getCatalogItems, getCatalogCards, isOk,
  adminSavePokemon, adminDeletePokemon,
  adminSaveItem, adminDeleteItem,
  adminSaveCard, adminDeleteCard,
} from "Projects/CHAMP_championsjourney_project/Utils/ChampService";
import CatalogAutocomplete from "Projects/CHAMP_championsjourney_project/Components/CatalogAutocomplete/CatalogAutocomplete";

// ─── helpers de formulario vacío ─────────────────────────────────────────────

function emptyForm(type) {
  if (type === "pokemon") return {
    idPokemon: "", nombre: "", tipo1: "", tipo2: "", fase: "", region: "",
    ps: "", ataqueBase: "", criticoDado: "", evolucionaDe: null,
    metodoEvolucion: "NINGUNO", xpEvolucion: "", idObjetoEvolucion: null,
    descripcionRequisito: "", inicial: false, pokedexTexto: "",
    frontUuid: "", backUuid: "", debilidades: "", inmunidades: "", mos: "",
  };
  if (type === "items") return {
    nombre: "", tipo: "OBJETO", descripcion: "", precio: "",
    utilizable: false, efectoTipo: "", efectoValor: "",
  };
  return { nombre: "", clase: "", descripcion: "" };
}

function populateForm(type, it) {
  if (type === "pokemon") return {
    idPokemon: it.idPokemon,
    nombre: it.nombre || "", tipo1: it.tipo1 || "", tipo2: it.tipo2 || "",
    fase: it.fase ?? "", region: it.region || "",
    ps: it.ps ?? "", ataqueBase: it.ataqueBase || "", criticoDado: it.criticoDado || "",
    evolucionaDe: it.evolucionaDe ?? null, metodoEvolucion: it.metodoEvolucion || "NINGUNO",
    xpEvolucion: it.xpEvolucion ?? "", idObjetoEvolucion: it.idObjetoEvolucion ?? null,
    descripcionRequisito: it.descripcionRequisito || "", inicial: it.inicial || false,
    pokedexTexto: it.pokedexTexto || "", frontUuid: it.frontUuid || "", backUuid: it.backUuid || "",
    debilidades: (it.debilidades || []).join(", "),
    inmunidades: (it.inmunidades || []).join(", "),
    mos: (it.mos || []).join(", "),
  };
  if (type === "items") return {
    nombre: it.nombre || "", tipo: it.tipo || "OBJETO", descripcion: it.descripcion || "",
    precio: it.precio ?? "", utilizable: it.utilizable || false,
    efectoTipo: it.efectoTipo || "", efectoValor: it.efectoValor ?? "",
  };
  return { nombre: it.nombre || "", clase: it.clase || "", descripcion: it.descripcion || "" };
}

// ─── Confirmación de borrado inline ──────────────────────────────────────────

function ConfirmDeleteBar({ label, loading, onConfirm, onCancel }) {
  return (
    <div className="champ-cp-confirm">
      <p>¿Eliminar <strong>{label}</strong>? Esta acción no se puede deshacer.</p>
      <div className="champ-cp-confirm-actions">
        <MDBBtn size="sm" color="secondary" onClick={onCancel}>Cancelar</MDBBtn>
        <MDBBtn size="sm" color="danger" disabled={loading} onClick={onConfirm}>
          {loading ? "Eliminando…" : "Eliminar"}
        </MDBBtn>
      </div>
    </div>
  );
}

// ─── Formulario por tipo ──────────────────────────────────────────────────────

function AdminForm({ type, form, fc, pokemonOptions, itemOptions, isNew }) {
  if (type === "pokemon") return (
    <div className="champ-cp-form-grid">
      {isNew && (
        <MDBInput type="number" label="ID Pokémon *" value={form.idPokemon}
          onChange={(e) => fc("idPokemon", e.target.value)} className="champ-cp-col-half" />
      )}
      <MDBInput label="Nombre *" value={form.nombre}
        onChange={(e) => fc("nombre", e.target.value)} className="champ-cp-col-half" />
      <MDBInput label="Tipo 1" value={form.tipo1}
        onChange={(e) => fc("tipo1", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Tipo 2" value={form.tipo2}
        onChange={(e) => fc("tipo2", e.target.value)} className="champ-cp-col-third" />
      <MDBInput type="number" label="Fase" value={form.fase}
        onChange={(e) => fc("fase", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Región" value={form.region}
        onChange={(e) => fc("region", e.target.value)} className="champ-cp-col-third" />
      <MDBInput type="number" label="PS base" value={form.ps}
        onChange={(e) => fc("ps", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Ataque base" value={form.ataqueBase}
        onChange={(e) => fc("ataqueBase", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Crítico dado" value={form.criticoDado}
        onChange={(e) => fc("criticoDado", e.target.value)} className="champ-cp-col-third" />
      <div className="champ-cp-col-half">
        <CatalogAutocomplete label="Evoluciona de (Pokémon)" value={form.evolucionaDe}
          onChange={(id) => fc("evolucionaDe", id)} options={pokemonOptions} />
      </div>
      <MDBInput label="Método evolución" value={form.metodoEvolucion}
        onChange={(e) => fc("metodoEvolucion", e.target.value)} className="champ-cp-col-third" />
      <MDBInput type="number" label="XP evolución" value={form.xpEvolucion}
        onChange={(e) => fc("xpEvolucion", e.target.value)} className="champ-cp-col-third" />
      <div className="champ-cp-col-half">
        <CatalogAutocomplete label="Objeto evolución" value={form.idObjetoEvolucion}
          onChange={(id) => fc("idObjetoEvolucion", id)} options={itemOptions} />
      </div>
      <MDBInput label="Descripción requisito" value={form.descripcionRequisito}
        onChange={(e) => fc("descripcionRequisito", e.target.value)} className="champ-cp-col-full" />
      <MDBInput label="Debilidades (CSV)" value={form.debilidades}
        onChange={(e) => fc("debilidades", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Inmunidades (CSV)" value={form.inmunidades}
        onChange={(e) => fc("inmunidades", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="MO (CSV)" value={form.mos}
        onChange={(e) => fc("mos", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Front UUID" value={form.frontUuid}
        onChange={(e) => fc("frontUuid", e.target.value)} className="champ-cp-col-half" />
      <MDBInput label="Back UUID" value={form.backUuid}
        onChange={(e) => fc("backUuid", e.target.value)} className="champ-cp-col-half" />
      <label className="champ-cp-checkbox">
        <input type="checkbox" checked={!!form.inicial}
          onChange={(e) => fc("inicial", e.target.checked)} />
        Pokémon inicial
      </label>
      <MDBTextArea label="Texto Pokédex" rows={2} value={form.pokedexTexto}
        onChange={(e) => fc("pokedexTexto", e.target.value)} className="champ-cp-col-full" />
    </div>
  );
  if (type === "items") return (
    <div className="champ-cp-form-grid">
      <MDBInput label="Nombre *" value={form.nombre}
        onChange={(e) => fc("nombre", e.target.value)} className="champ-cp-col-half" />
      <MDBInput label="Tipo *" value={form.tipo}
        onChange={(e) => fc("tipo", e.target.value)} className="champ-cp-col-half" />
      <MDBInput type="number" label="Precio" value={form.precio}
        onChange={(e) => fc("precio", e.target.value)} className="champ-cp-col-third" />
      <MDBInput label="Efecto tipo" value={form.efectoTipo}
        onChange={(e) => fc("efectoTipo", e.target.value)} className="champ-cp-col-third" />
      <MDBInput type="number" label="Efecto valor" value={form.efectoValor}
        onChange={(e) => fc("efectoValor", e.target.value)} className="champ-cp-col-third" />
      <label className="champ-cp-checkbox">
        <input type="checkbox" checked={!!form.utilizable}
          onChange={(e) => fc("utilizable", e.target.checked)} />
        Utilizable
      </label>
      <MDBTextArea label="Descripción" rows={2} value={form.descripcion}
        onChange={(e) => fc("descripcion", e.target.value)} className="champ-cp-col-full" />
    </div>
  );
  return (
    <div className="champ-cp-form-grid">
      <MDBInput label="Nombre *" value={form.nombre}
        onChange={(e) => fc("nombre", e.target.value)} className="champ-cp-col-half" />
      <MDBInput label="Clase *" value={form.clase}
        onChange={(e) => fc("clase", e.target.value)} className="champ-cp-col-half" />
      <MDBTextArea label="Descripción" rows={3} value={form.descripcion}
        onChange={(e) => fc("descripcion", e.target.value)} className="champ-cp-col-full" />
    </div>
  );
}

// ─── Componente principal ─────────────────────────────────────────────────────

/**
 * Modal genérico para elegir un elemento del catálogo.
 * type: "pokemon" | "items" | "cards"
 * Cuando el usuario tiene APP_ADMIN/APP_MANAGER muestra controles CRUD inline.
 */
export default function CatalogPicker({ show, setShow, type, region, onPick }) {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(() => setShow(false), [setShow]);

  useEffect(() => {
    if (!show) return;
    setFilter("");
    setLoading(true);
    let promise;
    if (type === "pokemon") promise = getCatalogPokemon(region);
    else if (type === "items") promise = getCatalogItems();
    else promise = getCatalogCards();

    promise
      .then((res) => setItems(isOk(res) && Array.isArray(res.DATA) ? res.DATA : []))
      .finally(() => setLoading(false));
  }, [show, type, region]);

  const title =
    type === "pokemon" ? "Añadir Pokémon"
      : type === "items" ? "Añadir objeto"
        : "Añadir tarjeta";

  const term = filter.trim().toLowerCase();
  const filtered = items.filter((it) =>
    !term || (it.nombre || "").toLowerCase().includes(term)
  );

  function renderItem(it) {
    if (type === "pokemon") {
      return (
        <div
          key={it.idPokemon}
          className="champ-catalog-item"
          onClick={() => { onPick(it); setShow(false); }}
        >
          {it.frontUuid
            ? <img src={mfmThumbUrl(it.frontUuid)} alt={it.nombre} className="champ-poke-sprite" />
            : <div className="champ-poke-sprite" />}
          <div style={{ fontWeight: 700 }}>#{it.idPokemon} {it.nombre}</div>
          <div className="champ-text-muted">{it.tipo1}{it.tipo2 ? " / " + it.tipo2 : ""}</div>
        </div>
      );
    }
    const id = type === "items" ? it.idObjeto : it.idTarjeta;
    return (
      <div
        key={id}
        className="champ-catalog-item"
        onClick={() => { onPick(it); setShow(false); }}
      >
        <div style={{ fontWeight: 700 }}>{it.nombre}</div>
        <div className="champ-text-muted">{it.tipo || it.clase}</div>
      </div>
    );
  }

  return (
    <MDBModal show={show} onHide={handleClose} tabIndex="-1">
      <MDBModalDialog size="lg">
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>{title}</MDBModalTitle>
            <MDBBtn className="btn-close" color="none" onClick={handleClose} />
          </MDBModalHeader>
          <MDBModalBody>
            <MDBInput
              label="Buscar"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="mb-3"
            />
            {loading ? (
              <p className="champ-text-muted">Cargando catálogo…</p>
            ) : filtered.length === 0 ? (
              <p className="champ-text-muted">No hay elementos en el catálogo.</p>
            ) : (
              <div className="champ-catalog-grid">
                {filtered.map(renderItem)}
              </div>
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={handleClose}>Cerrar</MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
